import type { InferRpcDefinition } from "@redotech/rpc/definition";

import { getProcedure } from "./schema/get-procedure";
import { getVariables } from "./schema/get-variables";
import { saveProcedure } from "./schema/save-procedure";
import { searchDynamicVariable } from "./schema/search-dynamic-variable";

export const rpcDefinition = {
  getProcedure,
  getVariables,
  saveProcedure,
  searchDynamicVariable,
};

export type RedoProceduresRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
